
import { Component, Watch, Mixins } from 'vue-property-decorator'
import { isOptionalGoods } from '@/api/shoppingMall'
import math from '@/core/math'
import scroll from '@/mixins/scroll'
import PackageSelector from '@/components/PackageSelector/index.vue'
import { PackageListDto } from './buyCar'
import {
  getStoreShoppingCart,
  batchDelStoreShoppingCart,
  updateStoreShoppingCart,
  getStoreIsUse,
  getMinDeliverGoods,
  getSelfPickupPoint,
  getSendGoodsTime,
  getPickupGoodsTime,
  GetPreOrderInfoParamsDto,
  BuyCarListDto,
  BuyCarPackageListDto,
  MinConfigDto,
  PickupConfigDto,
  PickupDetailDto,
  SendGoodsTimeDto
} from '@/api/industryMall'
import { TabDto } from '@/api/goodsModule'
import { Action, Getter } from 'vuex-class'
import StepperTemp from '@/components/StepperTemp/index.vue'
import { LoginReturnDataDto } from '@/utils/h5ToApp'
import CountDown from '@/views/industryMall/buyCar/template/countDown.vue'
import store from '@/store'

Component.registerHooks(['beforeRouteEnter'])
@Component({
  name: 'buyMallCar',
  components: { PackageSelector, StepperTemp, CountDown }
})
export default class BuyCar extends Mixins(scroll) {
  @Getter companyId!: string
  @Getter tabModules!: Array<TabDto>
  @Getter info!: LoginReturnDataDto
  @Action setPreOrderParams!: (val: GetPreOrderInfoParamsDto) => void
  @Action setProviderId!: (val: string) => void
  @Getter topSafetyHeight!: number

  checkedAll = false
  isEdit = false
  refreshing = false
  shoppingList: BuyCarListDto[] = []
  totalClass = 0
  totalQuantity = 0
  totalAmount = ''
  shopIndex = 0
  goodsIndex = 0
  // 选中的店铺商品数据，用于下单时存储获取预提交订单入参数据
  checkShopData: GetPreOrderInfoParamsDto = {
    // buyCustomerId: ''
  }
  path = ''
  isActivated = false
  showTips = false
  minConfigs: Array<MinConfigDto> = [] // 最小金额配置
  pickupConfigs: Array<PickupDetailDto> = [] // 站点自提详细配置
  storeListMoney: Array<any> = [] // 记录每个店铺商品总额
  warnInfo = { // 警告配置
    storeName: '',
    storeId: '',
    needMoney: 1 // 还差多少钱
  }
  sendTimeConfigList: Array<SendGoodsTimeDto> = [] // 送货上门日期配置列表
  pickupTimeConfig: Array<PickupConfigDto> = [] //

  @Watch('shoppingList', { deep: true })
  changListValue(val: BuyCarListDto[]) {
    let totalClass = 0
    let totalQuantity = 0
    let totalAmount = 0
    let totalCount = 0
    let shopList = []
    this.storeListMoney = []
    if (val && val.length > 0) {
      val.forEach((item) => {
        if (item.goodsPackageList && item.goodsPackageList.length > 0) {
          const { classSum, quantitySum, amountSum } = this.calcSum(
            item.goodsPackageList
          )
          this.storeListMoney.push({ storeId: item.storeId, storeName: item.storeName, money: amountSum })
          totalClass = Number(math.mathAdd(totalClass, classSum))
          totalQuantity = Number(math.mathAdd(totalQuantity, quantitySum))
          totalAmount = Number(math.mathAdd(totalAmount, amountSum))
          const checkGoods = []
          item.goodsPackageList.forEach((i) => {
            if (i.isValid) {
              totalCount++
              if (i.isChecked) {
                checkGoods.push({
                  goodsId: i.goodsId,
                  packageId: i.packageId,
                  orderQuantity: i.orderQuantity
                })
              }
            }
          })
          console.log('item', item)
          if (checkGoods && checkGoods.length > 0) {
            shopList.push({
              // companyId: item.shopId,
              storeId: item.storeId,
              storeName: item.storeName,
              storeLogo: item.storeLogo,
              goodsPackageList: checkGoods
            })
          }
        }
      })
      // console.log('companyId',this.companyId)
      this.checkShopData.companyId = this.companyId
      this.checkShopData.storeList = shopList
    }
    // this.checkedAll = totalCount === totalClass
    this.totalClass = totalClass
    this.totalQuantity = totalQuantity
    this.totalAmount = totalAmount.toFixed(2)

    // console.log(this.totalClass, this.totalQuantity, this.totalAmount)
  }

  get checkResult() {
    return [].concat(
      ...this.shoppingList.map((item: BuyCarListDto) => {
        return item.goodsPackageList
          .filter((i) => i.isChecked)
          .map((i) => ({
            autoId: i.autoId
          }))
      })
    )
  }

  // 失效商品
  get invalidCheckResult() {
    return [].concat(...this.shoppingList.map((item:BuyCarListDto)=> {
      return item.goodsPackageList.filter((i) => !i.isValid).map((i)=>({
        autoId:i.autoId
      }))
    }))
  }

  get isTabModule () {
    return this.tabModules.find(t => t.route === '/buyMallCar').isShow
  }

  created() {
    this.getList()
    store.dispatch('getShopCarNum', this.info.partnerCompanyId)
    // this.setProviderId('') 清除掉的话会影响商品列表页进入购物车在返回时调用接口
  }

  mounted() {
    // 注册原生调用h5方法
    this.handleBackBuyCar()
    this.$addScrollListener('.buy-car-refresh')
  }

  activated() {
    // if (window.sessionStorage.getItem('refresh') === '1') {
    //   window.sessionStorage.setItem('refresh', '0')
    //   // this.getList()
    // }
    if (this.isActivated) {
      console.log('*** BuyCar activated')
      this.getList(true)
      this.$setScrollY()
    } else {
      this.isActivated = true
    }
  }

  deactivated () {
    this.$removeScrollListener()
  }

  /**
   * @description 清除失效商品
   */
  clearInvalidShop() {
    this.$confirmDialog.show({
      okText: '确认',
      cancelText: '取消',
      tips: '确认要删除失效商品吗?',
      onOk: () => {
        return this.delFunc(this.invalidCheckResult)
      }
    })
  }

  /**
   * @description 判断商城是否启用
   * @param storeId
   */
  getStoreIsUse(storeId: string) {
    return getStoreIsUse({ storeId }).then((res) => {
      if (res.data.isUse) {
        return true
      } else {
        return false
      }
    })
  }

  /* 进入商城 */
  async goStore(item) {
    let isUse = await this.getStoreIsUse(item.storeId)
    console.log('isUse', isUse)
    if (!isUse) {
      this.$toast('该店铺已停用。如有疑问，请联系我司工作人员')
      return
    }
    this.$router.push({
      path: '/shopMallInfo',
      query: {
        storeId: item.storeId
      }
    })
  }
  getList(isActivated = false) {
    // getShoppingCart({companyId: this.companyId}).then((res) => {
    getStoreShoppingCart({
      partnerCompanyId: this.info.partnerCompanyId,
      pageIndex: 1,
      pageSize: 20
    // }, !this.isActivated).then((res) => {
    }, true).then((res) => {
      if (isActivated) return this.handleActivityData(res.data.records)
      this.shoppingList = res.data.records || []
      if (this.shoppingList && this.shoppingList.length > 0) {
        this.shoppingList.forEach((item: BuyCarListDto) => {
          this.handleToggleData(item, null)
          item.isChecked = false
          // 无效商品要排在最后，前端处理
          item.goodsPackageList.sort((a, b) => b.isValid - a.isValid)
          item.goodsPackageList.forEach((p: BuyCarPackageListDto) => {
            p.isChecked = false
            p.isEdit = false
          })
        })
        this.shoppingList = JSON.parse(JSON.stringify(this.shoppingList))
        this.checkedAll = false
      }
    }).finally(() => {
      this.getStoreSettings()
      this.refreshing = false
    })
  }

  // 获取店铺配置：送货上门最低金额设置 & 站点自提配置
  getStoreSettings () {
    this.minConfigs = []
    this.pickupConfigs = []
    this.sendTimeConfigList = []
    this.pickupTimeConfig = []
    this.shoppingList.forEach(store => {
      const storeId = store.storeId
      // 获取送货上门最低金额配置
      getMinDeliverGoods({ storeId }, true).then((res: any) => {
        this.minConfigs.push({ storeId, ...res.data } as MinConfigDto)
      })
      // 获取各店铺送货上门时间设置
      getSendGoodsTime({ storeId }, true).then((res: any) => {
        this.sendTimeConfigList.push({ storeId, ...res.data })
      })
      // 获取是否开启站点自提配置
      getSelfPickupPoint({ storeId, buyCompanyId: this.companyId }, true).then((res: any) => {
        this.pickupConfigs.push({ storeId, ...res.data }  as PickupDetailDto)
      })
      // 获取各店铺自提时间设置
      getPickupGoodsTime({ storeId }, true).then((res: any) => {
        this.pickupTimeConfig.push({ storeId, ...res.data })
      })
    })
  }

  /** 从详情返回购物车处理选择数据问题 */
  handleActivityData(data: Array<BuyCarListDto>) {
    if (data && data.length > 0) {
      data.forEach((shop: BuyCarListDto) => {
        // 无效商品要排在最后，前端处理
        shop.goodsPackageList.sort((a, b) => b.isValid - a.isValid)
        const oldShopData = this.shoppingList.find(i => i.storeId === shop.storeId)
        this.handleToggleData(shop, oldShopData)
        if (!oldShopData || (shop.goodsPackageList.length > oldShopData.goodsPackageList.length)) {
          shop.isChecked = false
          this.checkedAll = false
        } else {
          shop.isChecked = oldShopData.isChecked
        }
        shop.goodsPackageList.forEach((p: BuyCarPackageListDto) => {
          const findItem = oldShopData?.goodsPackageList.find(i => i.autoId === p.autoId)
          if (findItem) {
            p.isChecked = findItem.isChecked
            p.isEdit = findItem.isEdit
          } else {
            p.isChecked = false
            p.isEdit = false
          }
        })
      })
      this.shoppingList = JSON.parse(JSON.stringify(data))
    }
  }

  /**
   * 下拉刷新
   * */
  onRefresh() {
    this.refreshing = true
    this.getList()
    store.dispatch('getShopCarNum', this.info.partnerCompanyId)
  }

  /**
   * 切换数量编辑状态
   * @param shopIndex 店铺列表下标
   * @param packageIndex 店铺下商品列表下标
   * @param isValid 是否有效
   */
  changeEdit(shopIndex, packageIndex, isValid) {
    if (!isValid) return
    this.$set(
      this.shoppingList[shopIndex].goodsPackageList[packageIndex],
      'isEdit',
      true
    )
  }

  /**
   * 以店铺为单位，计算种类，数量，金额
   * @param packageList 需计算的店铺数据
   */
  calcSum(packageList: BuyCarPackageListDto[]) {
    console.log('packageList', packageList)
    // 种类
    let classSum = 0
    // 数量
    let quantitySum = 0
    // 金额
    let amountSum = 0
    if (packageList && packageList.length > 0) {
      packageList.forEach((item: any) => {
        if (item.isChecked) {
          classSum = Number(math.mathAdd(classSum, 1))
          quantitySum = Number(math.mathAdd(quantitySum, item.orderQuantity))
          // if (item.packagePrice) {
          if (item.finalPrice) {
            if (item.activityPrice) {
              // 计算活动价格
              amountSum = Number(
                math.mathAdd(
                  amountSum,
                  math.mathMultiply(item.activityPrice, item.orderQuantity || 0)
                )
              )
            } else {
              amountSum = Number(
                math.mathAdd(
                  amountSum,
                  math.mathMultiply(item.finalPrice, item.orderQuantity || 0)
                )
              )
            }
          }
        }
      })
    }
    return { classSum, quantitySum, amountSum }
  }

  handleFunc() {
    // console.log('this.shoppingList',this.shoppingList)
    // console.log('this.validCheckResult',this.InvalidCheckResult)
    this.isEdit = !this.isEdit
    if (!this.isEdit) {
      this.shoppingList.forEach((list) => {
        list.goodsPackageList.forEach((i) => {
          if (!i.isValid) {
            i.isChecked = false
          }
        })
        this.checkGroupChecked(list)
      })
    } else {
      this.shoppingList.forEach((list) => {
        this.checkGroupChecked(list)
      })
    }
    this.checkCheckAll()
  }

  checkGroupChecked(list: BuyCarListDto) {
    list.isChecked = list.goodsPackageList
      .filter((item) => this.isEdit || item.isValid)
      .every((item) => item.isChecked)
  }

  /**
   * 购物车商品数量改变时，更新购物车
   * @param index 店铺列表下标
   * @param i 店铺商品列表下标
   * @param value 加购商品数量
   */
  changeQuantity(index, i, value, isBlur = true) {
    const goods = this.shoppingList[index].goodsPackageList[i]
    const param = {
      partnerCompanyId: this.info.partnerCompanyId,
      goodsId: goods.goodsId,
      autoId: goods.autoId,
      packageId: goods.packageId,
      // shopId: this.shoppingList[index].shopId,
      storeId: this.shoppingList[index].storeId,
      orderQuantity: value
    }
    console.log('this.shoppingList[index]', this.shoppingList[index])
    this.updateBuyCar(param)
  }

  /**
   * 更新购物车
   * */
  updateBuyCar(param) {
    // modifyShoppingCart(param, false)
    updateStoreShoppingCart(param, true)
      .then(() => {
        this.getList(true)
      })
      .catch(() => {})
  }

  /* 全选 */
  changeAll() {
    this.shoppingList.forEach((list) => {
      list.goodsPackageList.forEach((i) => {
        if (this.isEdit || i.isValid) {
          i.isChecked = this.checkedAll
        }
      })
      this.checkGroupChecked(list)
    })
  }

  checkCheckAll() {
    this.checkedAll = this.shoppingList.every((list) => {
      return list.goodsPackageList
        .filter((i) => this.isEdit || i.isValid)
        .every((i) => i.isChecked)
    })
  }

  /* 批量删除 */
  deleteShopCar() {
    console.log('this.checkResult', this.checkResult)
    if (this.checkResult.length <= 0) {
      return this.$toast('请先选择需要删除的商品')
    }
    this.$confirmDialog.show({
      okText: '确认',
      cancelText: '取消',
      tips: '确认要删除吗?',
      onOk: () => {
        return this.delFunc(this.checkResult)
      }
    })
  }
  delFunc(result: { autoId?: string }[]) {
    let params = {
      autoIdList: result
    }
    // removeShoppingCart(params)
    batchDelStoreShoppingCart(params)
      .then(() => {
        this.$toast.success('删除成功')
        this.getList()
        this.checkedAll = false
        this.isEdit = false
        store.dispatch('getShopCarNum', this.info.partnerCompanyId)
      })
      .catch(() => {
        this.$toast.fail('删除失败')
        this.checkedAll = false
        this.isEdit = false
      })
  }

  /* 单个商品删除 */
  delData(id: string) {
    const data = [{ autoId: id }]
    // this.$confirmDialog.show({
    //   okText: '确认',
    //   cancelText: '取消',
    //   tips: '确认要删除吗?',
    //   onOk: () => {
    //     return this.delFunc(data)
    //   }
    // })
    this.delFunc(data)
  }

  beforeClose({ position, instance }) {
    switch (position) {
      case 'cell':
        break
      case 'outside':
        instance.close()
        break
    }
  }

  toDetail(data: BuyCarPackageListDto, shopId: string) {
    if (!data.isValid) return false
    const params = {
      shopId: shopId,
      goodsId: data.goodsId,
      customerId: this.companyId
    }
    // isOptionalGoods(params)
    //   .then((res) => {
    //     if (res.data.isOptional) {
    // this.setProviderId(shopId)
    this.$router.push({
      path: '/goodsMallDetail',
      query: {
        goodsId: data.goodsId,
        storeId: shopId
      }
    })
    //   } else {
    //     this.$dialog
    //       .alert({
    //         message: '商品过期不存在'
    //       })
    //       .then(() => {
    //         this.getList()
    //       })
    //   }
    // })
    // .catch(() => {})
  }

  handleEmpty() {}

  /**
   * 选择规格之后 更新购物车
   * @param info 选择的套餐信息
   * @param selectValueList // 存储加购弹窗选中的规格，用于加购弹出窗设置默认选中的规格
   */
  getSelectPackageInfo(info: PackageListDto, selectValueList: string[]) {
    this.shoppingList[this.shopIndex].goodsPackageList[
      this.goodsIndex
    ].packageId = info.packageId
    this.shoppingList[this.shopIndex].goodsPackageList[
      this.goodsIndex
    ].packageNameDesc = info.packageNameDesc
    this.shoppingList[this.shopIndex].goodsPackageList[
      this.goodsIndex
    ].packageName = info.packageName
    const goods =
      this.shoppingList[this.shopIndex].goodsPackageList[this.goodsIndex]
    const param = {
      companyId: this.companyId,
      goodsId: goods.goodsId,
      autoId: goods.autoId,
      packageId: goods.packageId,
      // shopId: this.shoppingList[this.shopIndex].shopId,
      shopId: this.shoppingList[this.shopIndex].storeId,
      orderQuantity: goods.orderQuantity
    }
    // this.updateBuyCar(param)
  }

  /**
   * 打开选择规格弹窗
   * @param data 购物车当前商品数据
   * @param index 店铺列表下标
   * @param i 店铺商品列表下标
   */
  showRules(data: BuyCarPackageListDto, index, i) {
    this.shopIndex = index
    this.goodsIndex = i
    const params = {
      // shopId: this.shoppingList[index].shopId,
      shopId: this.shoppingList[index].storeId,
      goodsId: data.goodsId,
      customerId: this.companyId
    }
    isOptionalGoods(params)
      .then((res) => {
        if (res.data.isOptional) {
          ;(this.$refs.packageSelector as any).show({
            ruleType: '4', // type ’1‘加入购物车  ’2‘立即下单  ’3‘选择规格可加购可下单   '4'选择规格确认
            detailInfo: data,
            defaultInfo: data,
            selectValueList: data.packageName.split(',')
          })
        } else {
          this.$dialog
            .alert({
              message: '商品过期不存在'
            })
            .then(() => {
              // window.location.reload()
              this.getList()
            })
        }
      })
      .catch(() => {})
  }

  /* 下单 */
  submitOrder() {
    // this.showTips = true
    if (this.checkResult.length <= 0) {
      return this.$toast('请先选择需要下单的商品')
    }
    console.log(`this.checkShopData = ${JSON.stringify(this.checkShopData)}`)
    for (let i = 0; i < this.storeListMoney.length; i++) {
      const storeInfo = this.storeListMoney[i]
      if (storeInfo.money > 0) {
        const minConfig = this.minConfigs.find(i => i.storeId === storeInfo.storeId)
        const pickupConfig = this.pickupConfigs.find(i => i.storeId === storeInfo.storeId)
        // const pickupConfig = this.pickupConfigs.find(i => i.storeId === storeInfo.storeId)
        // 如果开启送货上门最低金额设置且不满足最低金额 // &&  未开启上门自提( && pickupConfig.pickupStatus === '0')
        if (minConfig.minDeliverGoodsStatus === 1 && storeInfo.money < minConfig.minDeliverGoodsMoney && pickupConfig.pickupStatus === '0') {
          this.warnInfo.storeId = storeInfo.storeId
          this.warnInfo.storeName = storeInfo.storeName
          this.warnInfo.needMoney = Number(math.mathSubtract(minConfig.minDeliverGoodsMoney, storeInfo.money))
          this.showTips = true
          return
        }
        const store = this.checkShopData.storeList.find(ii => ii.storeId === storeInfo.storeId)
        const sendConfig = this.sendTimeConfigList.find(ii => ii.storeId === storeInfo.storeId)
        const pickupTimeConfig = this.pickupTimeConfig.find(ii => ii.storeId === storeInfo.storeId)
        if (store) store.distributionWay = 1
        if (store) {
          store.sendConfig = { ...sendConfig }
          store.pickupConfig = { ...pickupConfig }
          store.pickupTimeConfig = { ...pickupTimeConfig }
        }
        // 如果开启送货上门最低金额设置且满足最低金额
        if (minConfig.minDeliverGoodsStatus === 1 && storeInfo.money >= minConfig.minDeliverGoodsMoney) {
          const store = this.checkShopData.storeList.find(ii => ii.storeId === storeInfo.storeId)
          if (store) store.distributionWay = 1
        }
        // 如果开启送货上门最低金额设置且不满足最低金额 && 开启了上门自提
        if ((minConfig.minDeliverGoodsStatus === 1 && storeInfo.money < minConfig.minDeliverGoodsMoney) && pickupConfig.pickupStatus === '1') {
          const store = this.checkShopData.storeList.find(ii => ii.storeId === storeInfo.storeId)
          if (store) store.distributionWay = 2
        }
      }
    }
    /* 存储获取预提交订单信息入参数据 */
    this.checkShopData.distributionWay = 1
    this.setPreOrderParams(this.checkShopData)
    this.$router.push({
      path: '/submitMallOrder',
      query: {
        cartFlag: '1' // '1'是购物车进入
      }
    })
  }

  handleBack() {
    this.$router.back()
  }

  // app调用js的方法 跳转回客户管理页面（购物车页面物理返回键需要调用）
  handleBackBuyCar() {
    this.$bridge.registerHandler('handleBackBuyCar', () => {
      this.$router.back()
    })
  }

  // 处理是否显示 展开/收起 底部栏
  handleToggleData(item: BuyCarListDto, oldItem: BuyCarListDto) {
    if (!oldItem) {
      const unValidArray = item.goodsPackageList.filter(item => !item.isValid)
      if (!unValidArray || unValidArray.length < 2) {
        item.showMore = 0
      } else {
        item.showMore = 1
      }
      unValidArray.forEach((p: BuyCarPackageListDto, index: number) => {
        if (index > 0) {
          p.isHidden = true
        }
      })
    } else {
      item.showMore = oldItem.showMore
      this.hiddenData(item)
    }
  }

  // 展开 / 收起逻辑
  unfoldFn(item: BuyCarListDto) {
    item.showMore = item.showMore === 1 ? -1 : 1
    this.hiddenData(item)
  }

  // 处理是否隐藏商品
  hiddenData(item: BuyCarListDto) {
    const unValidArray = item.goodsPackageList.filter(item => !item.isValid)
    unValidArray.forEach((good: BuyCarPackageListDto, index: number) => {
      if (item.showMore === -1) {
        good.isHidden = false
      } else {
        if (index > 0) {
          good.isHidden = true
        }
      }
    })
  }

  // 去凑单
  goCollectOrders () {
    this.showTips = false
    this.goStore({ storeId: this.warnInfo.storeId })
  }
}
